// Reactjs library
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
// Common
import { RedirectWithComponent } from '../Constants/Utils';
import { CompanySelected, LoginFreee } from '../Constants/ConstantsValue';
// Action
import { loginFA, logoutWI } from '../Store/Actions/Pages/AccessPage';
import { getCompanies, getOperableFiscalPeriods, setSelectedFiscalPeriodInfo, validateAccessKey } from '../Store/Actions/Pages/MainPage';
import { setActiveAll, setDisableAll, setDisableById } from "../Store/Actions/Common/ActionState";
// Component & Class
import { BaseRequestModel } from '../Models/RequestModel/BaseRequestModel';
import Loading from "../Components/Common/Loading";
import CmbFiscalPeriod from "../Components/Pages/MainPage/CmbFiscalPeriod";
import GridContent from '../Components/Pages/MainPage/GridContent';
import SelectCompany from '../Components/Pages/MainPage/SelectCompany';
import { MessageBoxKey, MessageBoxModel } from '../Models/CommonModel/MessageBoxModel';
import MessageBox, { ConfirmMessageResult, Pattern, Title } from '../Components/Common/MessageBox';
import { SelectedFiscalPeriodStateModel } from '../Models/StateModel/FiscalPeriodInfoStateModel';
import { CookieAuthenModel } from '../Models/CommonModel/CookieAuthenModel';
import { storageModel } from '../Models/CommonModel/StorageModel';
import { AllActionId } from '../Models/StateModel/ActionStateModel';
// Resource + CSS
import Screen from "../Resources/Screen.json";
import MessageUI from "../Resources/MessageUI.json";
import Router from '../Resources/Router.json';
import "../Assets/Pages/MainPage.css";


function MainPage(props) {
    const cookieAuthenModel = new CookieAuthenModel();
    // Mapping state from store
    const loading = useSelector(state => state.ClientRequest.loading);
    const companyModels = useSelector(state => state.MainPage.companiesModel);

    // Action caller
    const dispatch = useDispatch();

    // Select company screen    
    const [companyData, setCompanyData] = useState([]);
    const [isSelectedCompany, setIsSelectedCompany] = useState(false);

    // MessageBox
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [messageDialog, setMessageDialog] = useState(null);
    const [isAuthen, setIsAuthen] = useState(false);

    useEffect(() => {
        // Check user is login using cookie
        let loginModel = cookieAuthenModel.GetWILoginModel();
        if (!loginModel) {
            // Return login page
            RedirectWithComponent("/");
            return;
        }

        let params = new BaseRequestModel({
            AccessKey: loginModel.AccessKey,
            RequestKey: loginModel.RequestKey
        });


        const callBack = (res) => {
            if (!res)
                return RedirectWithComponent(Router.Error);

            setIsAuthen(true);

            // Go to page select company if not seleted
            var companySelectedLocal = storageModel.GetItem(CompanySelected);
            if (companySelectedLocal) {
                setIsSelectedCompany(true);

                let action = getOperableFiscalPeriods(params, checkFinancialStatements);
                dispatch(action);
            }
            else {
                let getCompaniesAction = getCompanies();
                dispatch(getCompaniesAction);
            }
        }


        // Validate AccessKey
        let action = validateAccessKey(params, callBack);
        dispatch(action);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (companyModels && companyModels.Companies) {
            setCompanyData(companyModels.Companies);
            var companySelectedLocal = storageModel.GetItem(CompanySelected);
            if (companySelectedLocal) {
                var conpanySelectedExsit = companyModels.Companies.find(e => e.Id === companySelectedLocal.Id);
                if (!conpanySelectedExsit) {
                    storageModel.DeleteItem(CompanySelected);
                }
            }
        }
        else {
            setCompanyData([]);
        }
    }, [companyModels]);

    const selectCompany = (canExcute) => {
        if (!canExcute) {
            let dialog = new MessageBoxModel({
                Sid: MessageBoxKey.SelectCompany,
                Title: Title.DefaultTitle,
                Pattern: Pattern.OkCancel,
                Message: Screen.MessageBox.SelectCompany
            });
            return raiseMessageBox(dialog);
        }

        // Remove company selected
        storageModel.DeleteItem(CompanySelected);

        // Reset company data
        setCompanyData([]);
        setIsSelectedCompany(false);

        let cookieAuthenModel = new CookieAuthenModel();
        if (document.cookie && cookieAuthenModel.IsFreeeAuthorization()) {
            let getCompaniesAction = getCompanies();
            dispatch(getCompaniesAction);
        }
        else {
            dispatch(loginFA(LoginFreee));
        }
    }

    const reloadFiscalPeriod = (canExcute) => {
        if (!canExcute) {
            let dialog = new MessageBoxModel({
                Sid: MessageBoxKey.ReloadFiscalPeriod,
                Title: Title.DefaultTitle,
                Pattern: Pattern.OkCancel,
                Message: Screen.MessageBox.ReloadFiscalPeriod
            });
            return raiseMessageBox(dialog);
        }

        let loginModel = cookieAuthenModel.GetWILoginModel();
        if (!loginModel) {
            RedirectWithComponent(Router.Error);
            return;
        }

        let params = {
            AccessKey: loginModel.AccessKey,
            RequestKey: loginModel.RequestKey
        }
        let action = getOperableFiscalPeriods(params, checkFinancialStatements);
        dispatch(action);
    }

    const checkFinancialStatements = (res) => {
        if (!res)
            return RedirectWithComponent(Router.Error);

        setIsSelectedCompany(true);
        if (res.statusCode !== 200) {
            // Set disable all except BtnReloadFiscalPeriod
            let disabelIdsState = Object.assign({}, AllActionId);

            if (res.data?.ResultSubCode === MessageUI.SesstionTimeOutResultSubCode) {
                // Is sesstion timeout
                dispatch(setDisableAll());
            }
            else {
                // Is load OperableFiscalPeriods error
                delete disabelIdsState.BtnReloadFiscalPeriod;
                dispatch(setDisableById(disabelIdsState));
            }

            if (res?.data?.UserMessage) {
                let dialog = new MessageBoxModel({
                    Sid: MessageBoxKey.CheckFiscalPeriod,
                    Title: res.data.UserMessage,
                    Pattern: Pattern.OkCancel,
                    Message: res.data.DetailMessage
                });
                raiseMessageBox(dialog);
            }
        }
        else {
            dispatch(setActiveAll());
        }
    }

    const onSelectionChange = (selectedFiscalPeriod, selectedAccTypeData) => {
        let model = new SelectedFiscalPeriodStateModel({
            FiscalPeriodIndex: selectedFiscalPeriod.Index,
            AccTypeIndex: selectedAccTypeData.Value
        });

        dispatch(setSelectedFiscalPeriodInfo(model));
    }

    const raiseMessageBox = (dialog) => {
        setMessageDialog(dialog);
        setShowMessageBox(true);
    }

    const onSubmitMessageBox = (sid, value) => {
        switch (sid) {
            case MessageBoxKey.ReloadFiscalPeriod:
                if (value === ConfirmMessageResult.Yes) {
                    reloadFiscalPeriod(true);
                }
                break;

            case MessageBoxKey.SelectCompany:
                if (value === ConfirmMessageResult.Yes) {
                    selectCompany(true);
                }
                break;

            case MessageBoxKey.CheckFiscalPeriod:
                if (value === ConfirmMessageResult.Yes) {
                    let loginModel = cookieAuthenModel.GetWILoginModel();
                    let params = {
                        AccessKey: loginModel.AccessKey,
                        RequestKey: loginModel.RequestKey
                    };

                    const callBack = (res) => {
                        if (!res)
                            return RedirectWithComponent(Router.Error);

                        return RedirectWithComponent('/');
                    };

                    const logoutAction = logoutWI(params, true, callBack);
                    dispatch(logoutAction);
                }
                break;

            default:
                break;
        }

        // reset dialog & close
        setMessageDialog(null);
        setShowMessageBox(false);
    }

    return <div id="main-page">
        {messageDialog && showMessageBox && <MessageBox sid={messageDialog.Sid} title={messageDialog.Title} pattern={messageDialog.Pattern} message={messageDialog.Message} submit={onSubmitMessageBox}></MessageBox>}
        {(loading || !isAuthen) && <Loading />}
        {isAuthen &&
            <React.Fragment>
                <div className={"title-main"} style={{ textAlign: "center", margin: "0px" }}>
                    <img className='logo-freee' alt="Logo freee" border="0" id="ss_img" src={'/' + process.env.REACT_APP_SUB_FOLDER + "/freee_logo_kaikei_04_color_RGB_04_XXL.png"} />
                    <label className="mainPath">{Screen.MainPage.Title}</label>
                </div>
                <div className="pnxContainer">
                    {!isSelectedCompany && <SelectCompany companyData={companyData} seletedCompany={checkFinancialStatements} />}
                    {isSelectedCompany &&
                        <React.Fragment>
                            <div className="row">
                                <div className="col-left"></div>
                                <div className="col-center" style={{ paddingLeft: "0px" }}>
                                    <CmbFiscalPeriod
                                        selectCompany={selectCompany}
                                        reloadFiscalPeriod={reloadFiscalPeriod}
                                        selectionChange={onSelectionChange}
                                    />
                                </div>
                                <div className="col-right"></div>
                            </div>
                            <GridContent />
                        </React.Fragment>
                    }
                </div>
            </React.Fragment>
        }
    </div>
}

export default withRouter(MainPage);